import { motion, AnimatePresence } from 'framer-motion';
import type { ReactNode } from 'react';

interface Props {
  stepKey: number;
  label: string;
  helper?: string;
  children: ReactNode;
}

export function QuestionCard({ stepKey, label, helper, children }: Props) {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={stepKey}
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -30 }}
        transition={{ duration: 0.3, ease: 'easeOut' }}
        className="hit-card mx-4 mb-6"
      >
        <h2 className="text-xl font-extrabold italic text-hit-black mb-2 leading-snug">
          {label}
          <span className="text-hit-required ml-1" aria-hidden="true">
            *
          </span>
        </h2>

        {helper && (
          <p className="text-sm text-hit-gray-dark mb-4 leading-relaxed">{helper}</p>
        )}

        <div className="mt-4">{children}</div>
      </motion.div>
    </AnimatePresence>
  );
}
